import {
	Id,
	LaravelResponse,
	ModelUsageResource,
	PaginatedListFetcherConfig,
	createCrudService,
	keyToUrl,
	mapPaginatedFetcherConfigToAxiosConfig,
} from "@dgs/core";
import axios from "axios";
import {
	ContactTypeIndexResource,
	ContactTypeOptionResource,
	ContactTypeSaveRequest,
	ContactTypeUpdateResource,
} from "../types/contactType";

const baseKey = ["contact-types"];
const contactTypeCrudService = createCrudService<
	ContactTypeIndexResource,
	ContactTypeOptionResource,
	ContactTypeUpdateResource,
	ContactTypeSaveRequest
>(baseKey);
const showUsageKey = (contactTypeId: Id) => [...contactTypeCrudService.showKey(contactTypeId), "usage"];

export const contactTypeService = {
	...contactTypeCrudService,
	baseKey,
	index: (config: PaginatedListFetcherConfig<any>) =>
		axios.get<LaravelResponse<ContactTypeIndexResource[]>>(keyToUrl(baseKey), {
			params: { ...mapPaginatedFetcherConfigToAxiosConfig(config).params, orderBy: config.sortParams },
		}),
	showUsageKey,
	showUsage: (contactTypeId: Id) =>
		axios.get<LaravelResponse<ModelUsageResource[]>>(keyToUrl(showUsageKey(contactTypeId))),

	invalidateAll: (queryClient: any) => {
		queryClient.resetQueries({ queryKey: baseKey });
	},
};
